export default "<ul class=\"navbar-nav mr-auto\">\n  <li class=\"nav-item\">\n    <app-nav-search *ngIf=\"false\"></app-nav-search>\n  </li>\n</ul>\n"